import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-navy text-slate-400 py-12 border-t border-slate-800" data-id="element-7">
      <div className="container mx-auto px-4" data-id="element-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-9">
          <div className="col-span-1 md:col-span-2" data-id="element-10">
            <Logo dark className="mb-4" data-id="element-11" />
            <p className="text-sm max-w-xs" data-id="element-12">
              Plataforma de inteligencia para licitaciones. Entiende cada
              documento mejor que tus competidores.
            </p>
          </div>

          <div data-id="element-13">
            <h3 className="text-white font-semibold mb-4" data-id="element-14">Producto</h3>
            <ul className="space-y-2 text-sm" data-id="element-15">
              <li data-id="element-16">
                <a href="#como-funciona" className="hover:text-white transition-colors" data-id="element-17">
                  Cómo funciona
                </a>
              </li>
              <li data-id="element-18">
                <a href="#para-quien" className="hover:text-white transition-colors" data-id="element-19">
                  Casos de uso
                </a>
              </li>
              <li data-id="element-20">
                <a href="#ventaja" className="hover:text-white transition-colors" data-id="element-21">
                  Ventaja competitiva
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-22">
            <h3 className="text-white font-semibold mb-4" data-id="element-23">Empresa</h3>
            <ul className="space-y-2 text-sm" data-id="element-24">
              <li data-id="element-25">
                <a href="#vision" className="hover:text-white transition-colors" data-id="element-26">
                  Visión
                </a>
              </li>
              <li data-id="element-27">
                <a href="#" className="hover:text-white transition-colors" data-id="element-28">
                  Contacto
                </a>
              </li>
              <li data-id="element-29">
                <a href="#" className="hover:text-white transition-colors" data-id="element-30">
                  Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-sm flex flex-col sm:flex-row items-center justify-between" data-id="element-31">
          <p data-id="element-32">© 2026 PRISMA. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}